/**
 * Persistencia de módulos abiertos (navbar / menú Inicio).
 * Un id numérico por módulo: restore y append no duplican.
 */

export function parseOpenModuleIds(raw: string | null | undefined): number[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    const seen = new Set<number>();
    const ids: number[] = [];
    for (const item of parsed) {
      const id = Number(item);
      if (!Number.isInteger(id) || id <= 0 || seen.has(id)) continue;
      seen.add(id);
      ids.push(id);
    }
    return ids;
  } catch {
    return [];
  }
}

export function uniqueOpenModules<T extends { id: number }>(modules: T[]): T[] {
  const seen = new Set<number>();
  const out: T[] = [];
  for (const m of modules) {
    const id = Number(m.id);
    if (!Number.isInteger(id) || id <= 0 || seen.has(id)) continue;
    seen.add(id);
    out.push(m.id === id ? m : { ...m, id });
  }
  return out;
}

/** Updater: mira `prev`, no el array del render. Evita dupes por carrera / StrictMode. */
export function appendOpenModuleIfAbsent<T extends { id: number }>(
  prev: T[],
  item: T,
): T[] {
  const id = Number(item.id);
  if (!Number.isInteger(id) || id <= 0) return prev;
  if (prev.some((m) => Number(m.id) === id)) return prev;
  return [...prev, item.id === id ? item : { ...item, id }];
}
